import _ from 'lodash';
import constants from './constants';
import message from 'framework/modules/message';

const travelerFee = {
    has(fees) {
        return !_.isUndefined(this.get(fees));
    },

    isCoreCurrency(fee) {
        if (_.isObject(fee)) {
            if (!_.isObject(fee.transactableAmount)) {
                return true;
            }
            return (
                fee.amount.currencyCode.toLowerCase() ===
                fee.transactableAmount.currencyCode.toLowerCase()
            );
        }

        return false;
    },

    get(fees) {
        const travelerFeeItem = _.find(fees, (fee) => {
            return fee.type === constants.travelerFee.TRAVELER_FEE;
        });

        if (_.isObject(travelerFeeItem)) {
            const vatRate = _.find(travelerFeeItem.taxes, (tax) => {
                return tax.type === constants.travelerFee.VAT;
            });
            const gstRate = _.find(travelerFeeItem.taxes, (tax) => {
                return tax.type === constants.travelerFee.GST;
            });

            travelerFeeItem.hasVatRate = _.isObject(vatRate);
            travelerFeeItem.hasGstRate = _.isObject(gstRate);
        }

        return travelerFeeItem;
    },

    getIfUnpaid(fees, paidOrderItems) {
        const paid = _.includes(
            paidOrderItems || [],
            constants.travelerFee.TRAVELER_FEE
        );

        return !paid ? this.get(fees) : null;
    },

    remove(fees) {
        return _.reject(fees, (fee) => {
            return fee.type === constants.travelerFee.TRAVELER_FEE;
        });
    },

    getTaxType(fee, type) {
        return _.find(fee.taxes, (tax) => {
            return type === tax.type;
        });
    },

    /**
     * Gets the VAT in the service fee if it exists
     * @param fee the service fee
     * @returns {object} VAT/taxType object if it exists, otherwise undefined
     */
    getVat(fee) {
        return this.getTaxType(fee, constants.travelerFee.VAT);
    },

    /**
     * Gets the GST in the service fee if it exists (HAAU only)
     * @param fee the service fee
     * @returns {object} GST/taxType object if it exists, otherwise undefined
     */

    getGst(fee) {
        return this.getTaxType(fee, constants.travelerFee.GST);
    },

    hasVatIncludedMsg(fees, complianceType) {
        if (this.has(fees)) {
            const travelerFeeObj = this.get(fees);
            const vat = this.getVat(travelerFeeObj);
            const gst = this.getGst(travelerFeeObj);
            return (
                _.isObject(vat) && !_.isObject(gst) && complianceType !== 'EU'
            );
        }
        return false;
    },

    getTaxIncludedMsg(fees, complianceType) {
        const hasTravelerFee = this.has(fees);
        let taxIncludedMsg;

        if (hasTravelerFee) {
            const travelerFeeObj = this.get(fees);

            // VAT message
            const vat = this.getVat(travelerFeeObj);
            if (_.isObject(vat) && complianceType !== 'EU') {
                taxIncludedMsg = message.read(
                    'traveler.checkout.vat.included',
                    {0: vat.rate}
                );
            }

            // GST message
            const gst = this.getGst(travelerFeeObj);
            if (_.isObject(gst) && complianceType !== 'EU') {
                taxIncludedMsg = message.read(
                    'traveler.checkout.gst.included',
                    {0: gst.rate}
                );
            }
        }

        return taxIncludedMsg;
    },
};

export default travelerFee;
